import {MRT_Row} from 'material-react-table';
import React from 'react';
import {Avatar, Label, Tooltip} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {type CreatorBrandSafetyVetting} from '@/types/creatorBrandSafetyVetting';
import styles from './CreatorCell.module.scss';

function CreatorCell({row}: {row: MRT_Row<CreatorBrandSafetyVetting>}) {
  const src = row.original.creatorImageUrl;

  return (
    <div className={styles.container}>
      <Tooltip
        title={translate('Live tracking is enabled')}
        placement="top"
        disableHoverListener={!row.original.isLiveTracking}
        arrow
      >
        <div className={row.original.isLiveTracking && styles.liveTracking}>
          <Avatar
            size="md"
            type={src ? 'picture' : 'placeholder'}
            src={src}
            className={styles.avatar}
          />
        </div>
      </Tooltip>
      <Label size="sm">{row.original.creatorName}</Label>
    </div>
  );
}

export default CreatorCell;
